import script from "./AddDaodian.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDaodian.vue?vue&type=script&setup=true&lang=js"

import "./AddDaodian.vue?vue&type=style&index=0&id=5dd056e6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd056e6"]])

export default __exports__